import initialState from './initialState';
import {INSERT_CUSTOMERS, SET_CUSTOMERS, PUT_CUSTOMER} from '../actions/CustomersActions';

export default function (state = initialState.customers, action) {
    switch (action.type) {
        case PUT_CUSTOMER: {
            const {data} = action.payload;
            const customerId = (data.id);

            return state.map(customer => {
                if (customerId) {
                    return customer.id === customerId ? data : customer;
                }
                // in the case where the customer that were are updating doesn't have id fallback to email.
                return customer.email === data.email ? data : customer;
            });
        }
        case SET_CUSTOMERS:
            return action.payload.data;
        case INSERT_CUSTOMERS: {
            return [...state, ...action.payload.data];
        }
        default:
            return state;
    }
}
